import { useEffect } from 'react'

import type { ButtonProps, IconButtonProps } from './button.types'

import { vui } from '../core'
import { DismissButton } from '../dismissButton'
import Button from './button'

export const AppButton = vui<'button', ButtonProps>((props, ref) => <Button ref={ref} variant="primary" {...props} />)
AppButton.displayName = 'AppButton'

// Declared before DismissButton so styled(IconButton) can reference it at module-eval time.
export const IconButton = vui<'button', IconButtonProps>((props, ref) => (
  <Button ref={ref} variant="secondary" {...props} />
))
IconButton.displayName = 'IconButton'

export const BackButton = vui<'button', IconButtonProps>((props, ref) => (
  <IconButton startIcon="uiArrowLeft" ref={ref} variant="tertiary" {...props} />
))
BackButton.displayName = 'BackButton'

/** @deprecated Renamed to `DismissButton`. Will be removed in VUI 6. */
export const CloseButton = vui<'button', IconButtonProps>((props, ref) => {
  useEffect(() => {
    if (process.env.NODE_ENV !== 'production') {
      console.warn('[VUI] `CloseButton` is deprecated. Use `DismissButton` instead. Will be removed in VUI 6.')
    }
  }, [])
  // Map unsupported sizes to DismissButton sizes
  const { size, ...restProps } = props
  const dismissSize = size === 'xl' ? 'lg' : size
  return <DismissButton ref={ref} size={dismissSize} {...restProps} />
})
CloseButton.displayName = 'CloseButton'

export const CTAButton = vui<'button', ButtonProps>((props, ref) => (
  <Button ref={ref} variant="primary" intent="success" {...props} />
))
CTAButton.displayName = 'CTAButton'

export const DangerButton = vui<'button', ButtonProps>((props, ref) => (
  <Button ref={ref} variant="primary" intent="danger" {...props} />
))
DangerButton.displayName = 'DangerButton'

export const LineButton = vui<'button', ButtonProps>((props, ref) => (
  <Button ref={ref} variant="secondary" {...props} />
))
LineButton.displayName = 'LineButton'

export const TextButton = vui<'button', ButtonProps>((props, ref) => <Button ref={ref} variant="tertiary" {...props} />)
TextButton.displayName = 'TextButton'
